var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 26,
    height: 26,
    transform: "translate(-3 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M19.556,8.26,17.262,7.7a7.573,7.573,0,0,0-.529-1.26L17.8,4.656a.586.586,0,0,0-.088-.716L16.056,2.283a.584.584,0,0,0-.716-.088L13.557,3.263A7.549,7.549,0,0,0,12.3,2.738L11.74.444A.586.586,0,0,0,11.172,0H8.828A.585.585,0,0,0,8.26.444s-.391,1.6-.564,2.294a7.522,7.522,0,0,0-1.33.566L4.518,2.195a.588.588,0,0,0-.716.088L2.145,3.94a.586.586,0,0,0-.088.716L3.2,6.565a7.551,7.551,0,0,0-.462,1.129L.444,8.26A.586.586,0,0,0,0,8.828v2.344a.585.585,0,0,0,.444.568l2.295.564a7.558,7.558,0,0,0,.539,1.281L2.255,15.291a.586.586,0,0,0,.088.716L4,17.664a.588.588,0,0,0,.716.088l1.709-1.024a7.549,7.549,0,0,0,1.271.535l.564,2.294A.585.585,0,0,0,8.828,20h2.344a.586.586,0,0,0,.568-.444l.564-2.294a7.443,7.443,0,0,0,1.3-.552l1.736,1.041a.586.586,0,0,0,.716-.088l1.657-1.657a.586.586,0,0,0,.088-.716l-1.053-1.755a7.5,7.5,0,0,0,.514-1.231l2.294-.564A.586.586,0,0,0,20,11.172V8.828A.586.586,0,0,0,19.556,8.26ZM10,14.1A4.1,4.1,0,1,1,14.1,10,4.107,4.107,0,0,1,10,14.1Z",
    fill: "#3398cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2b3e4a37585c2890316b8d7c0a0f4729.svg";
export { ForwardRef as ReactComponent };